<template>
  <div class="container">
    <div
      class="row justify-content-center"
      v-if="!classloading"
    >
      <div class="col-md-12 mt-4">
        <b-button
          variant="secondary"
          @click.prevent="retClick"
          class="mr-3"
        ><i
            class="fas fa-chevron-left text-grey"
            aria-hidden="true"
          ></i></b-button>
        <h2>{{classinfo.gclass.name}}</h2>
        <h4>Time: {{formatDateDisplay(classinfo.start_at)}} [{{getTimeFromDateFormat(classinfo.start_at)}} to {{getTimeFromDateFormat(classinfo.end_at)}}]</h4>
        <h4>Coach: {{classinfo.coach.nickname}}</h4>
        <h4>Room: {{classinfo.room.name}}</h4>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-md-5">
        <div class="d-flex justify-content-center">
          <div class="input-group">
            <input
              @keyup="memberSearch"
              class="form-control"
              type="text"
              id="memberSearchInput"
              name="memberSearchInput"
              v-model="memberSearchInput"
              placeholder="Search member ID, name, or email.."
              aria-label="Search member ID, name, or email.."
            />
            <div class="input-group-append">
              <span
                class="input-group-text pl-4 pr-4"
                id="searchbtt"
                @click.prevent="memberSearch"
              ><i
                  class="fas fa-search text-grey"
                  aria-hidden="true"
                ></i></span>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="row">
      <div class="col-md-5">
        <div>
          <h5 v-if="isSearch">Search Result:</h5>
          <sale-member-table
            v-if="isSearch"
            :memberResult="memberResult"
            v-on:member-created="memberCreated"
          ></sale-member-table>
        </div>
        <!--<test-table></test-table>-->
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-md-12 mt-4">
        <table
          class="table table-sm"
          v-if="!loading"
        >
          <thead>
            <tr>
              <th scope="col">Mem ID</th>
              <th scope="col">Name</th>
              <th scope="col">Tel</th>
              <th scope="col">Package <b-spinner
                  class="align-middle mt-1 checkspin"
                  style="float:right"
                  small
                  v-if="checkinloading"
                ></b-spinner>
              </th>
              <th
                scope="col"
                class="text-right"
              >Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in members"
              :key="index"
            >
              <td>
                <a
                  href="#"
                  @click.prevent="
                  $router.push({
                    name: 'MemberHome',
                    params: { id: item.id },
                  })
                "
                >{{item.cardid}}</a>

              </td>
              <td>
                {{item.firstname}} {{item.lastname}} <span v-if="item.nickname!=null">({{item.nickname}})</span>
              </td>
              <td>{{ item.phone }}</td>
              <td>
                <div v-if="item.memberpackage.length>0">
                  <div
                    class="pb-2 clearfix"
                    v-for="(mempitem, mempindex) in item.memberpackage"
                    :key="mempindex"
                  >
                    <span>{{mempitem.package.fullname}} <span class="extranote">{{extranote(mempitem.package.type)}}</span></span>

                    <span
                      v-if="item.bookings[0].status=='LATECANCEL'"
                      style="float:right"
                      class="latecancel"
                    >LATE CANCEL</span>
                    <span
                      v-else
                      class=""
                      style="float:right"
                    ><input
                        type="checkbox"
                        class="form-check-input checkinbox"
                        id="memberpackage_status"
                        :disabled=checkinloading
                        :checked="(item.bookings[0].status=='SHOW' && item.bookings[0].memberpackage_id==mempitem.id)"
                        @click="checkin(item.bookings[0],mempitem.id,$event)"
                      />

                    </span>

                  </div>
                </div>
                <div v-else>
                  <span class="expirenote">MEMBERSHIP HAS EXPIRED / FREEZE</span>
                  <span
                    v-if="item.bookings[0].status=='LATECANCEL'"
                    style="float:right"
                    class="latecancel"
                  >LATE CANCEL</span>
                  <span
                    v-else
                    class=""
                    style="float:right"
                  ><input
                      type="checkbox"
                      class="form-check-input checkinbox"
                      id="memberpackage_status"
                      :disabled=checkinloading
                      :checked="(item.bookings[0].status=='SHOW')"
                      @click="checkin(item.bookings[0],null,$event)"
                    />

                  </span>
                </div>
              </td>
              <td class="text-right">
                <a
                  href="#"
                  @click.prevent="confirmRemoveMember(item.bookings[0].id)"
                  class="mr-2"
                >
                  <i class="fas fa-trash-alt removebtt"></i>
                </a>

              </td>
            </tr>
          </tbody>
        </table>
        <div
          v-else-if="loading"
          class="text-center my-2"
        >
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </div>
    </div>
    <div>
      <b-modal
        id="cf-modal"
        title="Comfirm"
        @ok="handleOk"
      >
        Confirm Remove Member?
      </b-modal>
    </div>
  </div>
</template>
<script>
import {
  formatDateDisplay,
  formatDateTimeDisplay,
  getTimeFromDateFormat
} from "./../js/utils/date.js";
import SaleMemberTable from "./SaleMemberTable.vue";
export default {
  data() {
    return {
      loading: false,
      checkinloading: false,
      classloading: true,
      removeloading: true,
      addloading: true,
      members: null,
      classinfo: null,
      currentBookingID: null,
      isSearch: false,
      memberSearchInput: null,
      memberResult: null,
      selectMember: null
    };
  },
  components: {
    SaleMemberTable
  },
  mounted() {
    this.getClassInfo();
    this.getMember();
  },
  computed: {},
  methods: {
    formatDateDisplay,
    formatDateTimeDisplay,
    getTimeFromDateFormat,
    retClick() {
      this.$router.push({ name: "GClasses" });
    },
    extranote(type) {
      switch (type) {
        case "OPG":
          return "";
          //return "[Extra 100 Baht.]";
          break;

        default:
          break;
      }
    },
    getClassInfo() {
      axios.get("/api/classes/info/" + this.$route.params.id).then(response => {
        //console.log(response.data);

        this.classinfo = response.data;

        this.classloading = false;
      });
    },
    async memberSearch() {
      //console.log(this.memberSearchInput);

      if (
        this.memberSearchInput == "" ||
        this.memberSearchInput == null ||
        this.memberSearchInput.length < 2
      ) {
        return false;
      }

      this.isSearch = false;
      await axios
        .get("/api/members/find", {
          params: {
            keysearch: this.memberSearchInput
          }
        })
        .then(response => {
          //console.log(response.data);
          this.memberResult = response.data;

          //console.log(response.data.data);
          this.loading = false;
          this.isSearch = true;
        });
    },
    checkin(booking, memberpackage_id, event) {
      this.checkinloading = true;
      axios
        .post("/api/classes/checkinclass", {
          bookingid: booking.id,
          memberpackageid: memberpackage_id,
          ischeck: event.target.checked
        })
        .then(response => {
          //console.log(response.data);
          //this.members = response.data;
          this.checkinloading = false;
        });
    },
    async getMember() {
      //console.log(moment().format("DD/MM/YYYY"));
      this.loading = true;
      await axios
        .get("/api/classes/getmember/" + this.$route.params.id)
        .then(response => {
          //console.log(response.data);

          this.members = response.data;

          this.loading = false;
        });
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.removeCheckin();
    },
    confirmRemoveMember(id) {
      this.currentBookingID = id;
      this.$bvModal.show("cf-modal");
    },
    removeCheckin() {
      var bookingid = this.currentBookingID;
      this.removeloading = true;
      axios
        .post("/api/classes/removemember", {
          bookingid: bookingid,
          scheduleid: this.$route.params.id
        })
        .then(response => {
          //console.log(response.data);

          this.getMember();
        })
        .catch(function(error) {
          //console.log(error.response.data.errors);
          //if(error.response.data.errors.message =)
        })
        .finally(() => {
          this.$bvModal.hide("cf-modal");
          this.removeloading = false;
        });
    },
    memberCreated(data) {
      this.addloading = true;
      axios
        .post("/api/classes/addmember", {
          membercardid: data.cardid,
          scheduleid: this.$route.params.id,
          checkin: false
        })
        .then(response => {
          //console.log(response.data);

          this.getMember();
        })
        .catch(function(error) {
          //console.log(error.response.data.errors);
          //if(error.response.data.errors.message =)
        })
        .finally(() => {
          this.addloading = false;
        });
    }
  }
};
</script>
<style scoped>
.checkinbox {
  width: 20px;
  height: 20px;
}
.checkspin {
}
.latecancel {
  color: red;
  font-weight: bold;
}
.removebtt {
  font-size: 1.5em;
  color: grey;
}
.extranote {
  color: blueviolet;
  font-weight: bold;
}
.expirenote {
  color: red;
  font-weight: bold;
}
</style>